/**
 * Formato numérico es-PY confiable (independiente del soporte de Intl):
 * separador de miles "." y decimal ",". Ej: 7500 -> "7.500,00".
 */
export const formatNumberPY = (value, decimals = 2) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return "";
  const fixed = Math.abs(n).toFixed(decimals);
  const [intPart, decPart] = fixed.split(".");
  const withThousands = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  const sign = n < 0 ? "-" : "";
  return decPart != null ? `${sign}${withThousands},${decPart}` : `${sign}${withThousands}`;
};

/** Igual que formatNumberPY pero con la moneda al final. */
export const formatMoneyPY = (value, currency = "", decimals = 2) => {
  const num = formatNumberPY(value, decimals);
  return currency ? `${num} ${currency}` : num;
};
